module.exports = "<div class=\"col-md-6 col-xl-12 q-marg-bottom-md add-rma-itm-attr-div\"> <div class=row> <div class=\"col-md-6 col-xl-12\"> <span class=\"q-tag add-rma-itm-attr-name\"></span> </div> <div class=\"col-md-6 col-xl-12\"> <span class=add-rma-itm-attr-value></span> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/returnRequestsWizard/html/returnRequestsProductAttr.html
// module id = 1410
// module chunks = 1